import OriginSelect from './select.vue';
import SearchSelect from './search.vue';
import OriginOption from './option.vue';
OriginSelect.Option = OriginOption;
OriginSelect.Search = SearchSelect;
export default OriginSelect as typeof OriginSelect & {
  readonly Search: typeof SearchSelect;
  readonly Option: typeof OriginOption;
};
